var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',{attrs:{"hide-breadcrumbs":"","loding":_vm.ProfileLoading}},[(_vm.ProfileLoading)?_c('v-skeleton-loader',{attrs:{"type":"card"}}):_c('RecruitingProfileCard',{attrs:{"public-view":"","athleteProfile":_vm.athleteProfile,"sharingUrlId":_vm.sharingUrlId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }